





























































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetNationList, InsertNation, UpdateNationById, DeleteNation} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
@Component
export default class Country extends AbpBase {
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm:any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	created() {
		this.getData()
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
			(this.$refs.form as any).resetFields()
		}
	}
	columns = [
		{
			key: 'nationName',
			title: '民族名称'
		},
		{
			key: 'nationPY',
			title: '拼音助记符'
		},
		{
			key: 'nationWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.nationPY = res1
		this.dialogForm.nationWB = res2
	}
	createCounty() {
		this.dialogTitle = '新增民族'
		this.dialogForm = {status:true,nationPY:'',nationWB:''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetNationList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑民族'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteNation({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增民族') {
					let res = await InsertNation(this.dialogForm)
				} else if (this.dialogTitle === '编辑民族') {
					let res = await UpdateNationById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}
	rules = {
		nationName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		nationPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		nationWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/basicDictionary/nation/index.vue